import { render, staticRenderFns } from "./DesktopMetaNavigation.vue?vue&type=template&id=e7862612&scoped=true&"
import script from "./DesktopMetaNavigation.vue?vue&type=script&lang=js&"
export * from "./DesktopMetaNavigation.vue?vue&type=script&lang=js&"
import style0 from "./DesktopMetaNavigation.vue?vue&type=style&index=0&id=e7862612&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7862612",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavLink: require('/vercel/path0/components/navigation/NavLink.vue').default,PopoverButton: require('/vercel/path0/components/popover/PopoverButton.vue').default,TooltipBox: require('/vercel/path0/components/general/TooltipBox.vue').default,PopoverPanel: require('/vercel/path0/components/popover/PopoverPanel.vue').default,Popover: require('/vercel/path0/components/popover/Popover.vue').default})
